import { render } from "./AssignLeads.vue?vue&type=template&id=84c6779c"
import script from "./AssignLeads.vue?vue&type=script&lang=js"
export * from "./AssignLeads.vue?vue&type=script&lang=js"

import "./AssignLeads.vue?vue&type=style&index=0&id=84c6779c&lang=css"

import exportComponent from "C:\\pythonproject0\\tkrforntend\\tkrforntend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__